<template>
  <main>
    <div class="type">
      <div class="bar"></div>
      <div>
        <img :src="`/icons/${projectTypeIcon.UNDEFINED}-duotone.svg`" alt="Oops">
      </div>
      <div class="bar"></div>
    </div>

    <div class="excerpt">
      <h1 aria-label="Experiences and qualifications">Something went wrong</h1>
      <p>The page you were looking for doesn't exist...</p>
      <router-link class="navigation" :to="{ name: 'home' }" exact>Back to Home</router-link>
    </div>
  </main>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: "Error",
    computed: {
      ...mapState([
        'projectTypeIcon'
      ])
    }
  }
</script>

<style scoped lang="scss">
  @import '../assets/css/variables';
  @import '../assets/css/subpages';
</style>
